import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import "./casinocard.scss"
import casinos from "../../../content/casinos.json"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

const CasinoTable = ({ ids, showHeader }) => {
  const casinoLogos = useStaticQuery(graphql`{
  allFile(
    filter: {relativeDirectory: {eq: "casino"}, extension: {regex: "/(jpg)|(png)|(jpeg)/"}}
    sort: {base: DESC}
  ) {
    edges {
      node {
        base
        childImageSharp {
          gatsbyImageData(placeholder: NONE, formats: [WEBP], width: 800, quality: 100)
        }
      }
    }
  }
}`)

  return (
    <div className="casino-cards">
      {ids.map(i => casinos.map(item => i === item.id && (
        <div className="card" key={"row_" + item.id}>
          <div className="card-info">
            <GatsbyImage backgroundColor={item.bgColor} image={getImage(casinoLogos.allFile.edges.find(element => element.node.base === (item.id + ".png")).node.childImageSharp.gatsbyImageData)} alt={item.name} />
            <Link to={"/recensioner/" + item.id} className="card-name">{item.name}</Link>
          </div>
          <div className="card-bonus">
            <div className="pitch" dangerouslySetInnerHTML={{ __html: item.pitch }} />
          </div>
          <div className="card-play">
            <a href={item.url}>Besök</a>
          </div>
          <div className="card-tac">
            <span dangerouslySetInnerHTML={{ __html: item.tac }} />
          </div>
        </div>
      )))}
    </div>
  )
}


export default CasinoTable